import React, { useCallback, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Table as KSNMTable } from 'ksnm-common-ui/lib/Table2';
import { getLocalRowsByCheckBoxStatus } from 'ksnm-common-ui/lib/Table2/utils/getLocalRowsByCheckBoxStatus';

import { RoutePath } from '@components/AppRouter/constants';
import { getExcelWithAudit } from '@src/utils/getExcelWithAudit';
import { useTableTitleWithCount } from '@src/utils/hooks/useTableTitleWithCount';
import { useUpdateTable } from '@src/utils/hooks/useUpdateTable';
import { objectFieldsToSnakeCase } from '@src/utils/objectFieldsToCamelCase';
import { constantStore } from '@stores/constantStore';
import { controlGroupsStore } from '@stores/dictionaryStores/controlGroupsStore/controlGroupsStore';
import { ksnmTableStore } from '@stores/ksnmTableStore/ksnmTableStore';

import { ActionButton } from './ActionButton';
import { columns } from './columns';

import styles from './Table.module.scss';

const { TABLE_NAMES } = constantStore;

export const Table = observer(() => {
  const { breadcrumbs, controlGroups, setChecked } = controlGroupsStore;
  const { push } = useHistory();

  const [key, update, externalControl] = useUpdateTable({ tableName: TABLE_NAMES.DICTIONARY_CONTROL_GROUPS });

  useEffect(() => {
    update();
  }, [update]);

  const onCheckBoxChange = useCallback(
    async (tr, sr) => {
      // TODO переделать когда, в таблицном компоненте на беке добавят запрос для получение выбранных строк
      const rows = await getLocalRowsByCheckBoxStatus({
        tableRequest: { ...tr },
        localData: {
          data: controlGroups.map((item) => objectFieldsToSnakeCase(item)),
          fieldFormat: {},
        },
        selectRows: sr,
        keyField: 'ctrl_group_code',
      });

      setChecked(rows);
    },
    [controlGroups, setChecked],
  );

  const onRowClick = useCallback(
    (value) => {
      push(`${RoutePath.DICTIONARY_CONTROL_GROUPS}/${value?.ctrl_group_code}`);
    },
    [push],
  );

  const title = useMemo(
    () => (
      <div className={styles.breadcrumbs}>
        {breadcrumbs.map((value) => (
          <div key={value}>{value}</div>
        ))}
      </div>
    ),
    [breadcrumbs],
  );

  const [titleWithCount, onTableChange] = useTableTitleWithCount(title);

  return (
    <div className={styles.table}>
      <KSNMTable
        externalControl={externalControl}
        tableName={TABLE_NAMES.DICTIONARY_CONTROL_GROUPS}
        columns={columns}
        tableTitle={titleWithCount}
        resource="ctrl.nsi_ctrl_group"
        externalFetch={ksnmTableStore.externalFetch}
        externalFetchXLSX={getExcelWithAudit('Справочник "Группы контролей"')}
        onRowClick={onRowClick}
        onCheckBoxChange={onCheckBoxChange}
        extendTableButtons={<ActionButton update={update} />}
        showAggregateRow={false}
        key={key}
        keyField="ctrl_group_code"
        onTableChange={onTableChange}
      />
    </div>
  );
});
